import React, {Fragment} from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from 'formik';
import { compose} from "redux";
import { passReasonList } from 'constants/passReasons';
import {SectionTitle} from './FormSectionComponents';
import {
  SideLabelAutoCompleteInput,
  SideLabelTextAreaInput,
 } from './FormSectionComponents';

 const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;

const VerticalSpacer = styled.div`
height:30px;
display:block;
`

class PassedQuoteSection extends React.Component {
  state ={};

  render(){    
    const { isEditing } = this.props;
    
    return (
      <Fragment>
        <div id="passed_quote_section">
          <VerticalSpacer/>
          <SectionTitle id="passed_quote_section">Passed Quote</SectionTitle>
          <StyledGrid container alignItems="center" direction="column">

            <SideLabelAutoCompleteInput
              label="Pass Reason"
              fieldName="details.passReasonId"      
              id="dropdownForPassReason"      
              selectValue="value"
              options={passReasonList}
              isDisabled={!isEditing}
            />  
            <SideLabelTextAreaInput 
              label="Pass Comment"
              placeholder="Pass Comment"
              fieldName="details.passComment"
              isDisabled={!isEditing}/>
          </StyledGrid>
        </div>
      </Fragment>
  )};
}

const mapStateToProps = ({  }) => ({
});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
    {
    }
  )
)(PassedQuoteSection);
